<template>
  <v-card class="hero" :height="windowSize.y" v-resize="onResize">
    <div class="title" style="margin-top: -5px">
      <h1 class="text-h3">
        TDM
      </h1>
      <v-img src="../assets/tdm.png" style="height: 50%; width: 50%; margin: auto;" />
      <h1 class="text-h3 mb-2">
        Dashboard
      </h1>
      <div class="d-flex align-center justify-center">
        <v-btn color="black" 
          class="mt-4" 
          @click="signIn()">
          Sign In
        </v-btn>
      </div>
      <v-card v-if="noAccess" class="elevation-2">
        <h3 class="mt-4 error white--text pa-5">
          Access Denied
        </h3>
      </v-card>
    </div>
    <v-overlay v-model="isBusy" class="align-center justify-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      isBusy: false,
      noAccess: false,
      windowSize: { x: 0, y: 0 },
    };
  },
  async mounted() {
    this.onResize();
  },
  methods: {
    ...mapActions(['storeSignIn']),
    async signIn() {
      this.isBusy = true;
      try {
        this.noAccess = false;
        await this.storeSignIn();
      } catch (error) {
        console.log(error);
        this.noAccess = true;
      }
      this.isBusy = false;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
  }
};
</script>

<style scoped>
.title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.hero h1 {
  text-shadow: 5px 3px 5px black;
  color: white;
}
</style>